export default {
  /**
   * @type {string} *
   * @description 系统标题
   */
  Title: "广西农垦西江乳业",

  /**
   * @type {string} *
   * @description 版权公司
   */
  copyrightCompany: "-",

};
